import { Link, Route, Routes, useParams } from 'react-router-dom';
import { ChevronRight, MapPinned } from 'lucide-react';

import horseParkLogo from './assets/horse-park-logo-white.png';
import { EventsPage } from './routes/EventsPage';
import { EventHome } from './routes/EventHome';
import { EntriesPage } from './routes/EntriesPage';
import { VolunteersPage } from './routes/VolunteersPage';
import { SchedulePage } from './routes/SchedulePage';
import { JumpsPage } from './routes/JumpsPage';
import { AssignmentsPage } from './routes/AssignmentsPage';
import {
  EventAdministrationHome,
  EventAdministrationLayout,
  EventAdministrationSettings,
  EventDataManagementPage,
  EventHistoryDetailPage,
  EventHistoryPage,
} from './routes/EventAdministration';

export function App() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-inner">
          <Link to="/" className="app-brand">
            <img className="app-brand-logo" src={horseParkLogo} alt="The Horse Park at Woodside" />
            <span className="app-brand-title">Cross Country Planner</span>
          </Link>
          <Breadcrumb />
        </div>
      </header>
      <main className="app-main">
        <Routes>
          <Route path="/" element={<EventsPage />} />
          <Route path="/events/:eventId" element={<EventHome />} />
          <Route path="/events/:eventId/entries" element={<EntriesPage />} />
          <Route path="/events/:eventId/volunteers" element={<VolunteersPage />} />
          <Route path="/events/:eventId/schedule" element={<SchedulePage />} />
          <Route path="/events/:eventId/jumps" element={<JumpsPage />} />
          <Route path="/events/:eventId/assignments" element={<AssignmentsPage />} />
          <Route path="/events/:eventId/admin" element={<EventAdministrationLayout />}>
            <Route index element={<EventAdministrationHome />} />
            <Route path="settings" element={<EventAdministrationSettings />} />
            <Route path="history" element={<EventHistoryPage />} />
            <Route path="history/:versionId" element={<EventHistoryDetailPage />} />
            <Route path="data" element={<EventDataManagementPage />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
}

function Breadcrumb() {
  const params = useParams();
  if (!params.eventId) return null;
  return (
    <span className="breadcrumb">
      <ChevronRight aria-hidden="true" />
      <Link to={`/events/${params.eventId}`}>
        <MapPinned aria-hidden="true" />
        Event workspace
      </Link>
    </span>
  );
}
